var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.784 11L4.204 7H0V5H4.415L4.94 0H6.951L6.426 5H10.415L10.94 0H12.951L12.426 5H16V7H12.216L11.796 11H16V13H11.585L11.06 18H9.049L9.574 13H5.585L5.06 18H3.049L3.574 13H0V11H3.784ZM5.795 11H9.785L10.205 7H6.215L5.795 11Z",
    fill: "#131313"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hash.5ef04dac.svg";
export { ForwardRef as ReactComponent };